module.exports = {
  __depends__: [ require(40) ],
  __init__: [ 'canvas' ],
  canvas: [ 'type', require(31) ],
  elementRegistry: [ 'type', require(33) ],
  elementFactory: [ 'type', require(32) ],
  eventBus: [ 'type', require(34) ],
  graphicsFactory: [ 'type', require(35) ]
};